<style lang="less" scoped>
ul li {
  list-style: none;
}
</style>
<template>
  <div>
    <Header ref="header"></Header>
    <priprentDetail></priprentDetail>
    <ComFooter></ComFooter>
  </div>
</template>
<script>
import ComFooter from "@/components/footer.vue";
import Header from "@/components/comHeader.vue";
import priprentDetail from "@/components/priprentDetail.vue";

export default {
  components: {
    ComFooter,
    Header,
    priprentDetail,
  },
  data() {
    return {
      title: this.$t("header.home27"),
    };
  },

  mounted() {
    this.$refs.header.title = this.title;
  },
  methods: {
    leftContent() {
      Indicator.close();
      this.$router.back();
    },
  },
};
</script>